/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-i18n-at-module-eval */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import I18n from 'I18n';
import ColouredBanner from './ColouredBanner';

const WeekOfRestBanner = ({
  startOn,
  stopOn
}) => {
  const [shouldShow, setShouldShow] = useState(false);
  useEffect(() => {
    const present = I18n.moment.utc().subtract(4, 'hours'); // convert to ET since .tz('America/New_York') is unavailable

    setShouldShow(present.isAfter(startOn) && present.isBefore(stopOn));
  }, [startOn, stopOn]);
  return shouldShow ? /*#__PURE__*/_jsx(ColouredBanner, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.weekOfRestBanner"
    })
  }) : null;
};

WeekOfRestBanner.defaultProps = {
  startOn: I18n.moment('2022-06-30'),
  stopOn: I18n.moment('2022-07-11')
};
export default WeekOfRestBanner;